import type {IProductDefault, IStoreShort} from "@/api/aj-trends.model.ts";

// Reference implementation: src/main/kotlin/de/wdw/aj/trends/application/WebLinksService.kt
export namespace WebLinks {
  const uriReplaceRegex = /(\s|[:@/?&=#%+\[\]!$()*,;])+/g

  export function productLink(product: IProductDefault) {
    const {productHash, brandName, productName} = product
    const slug = slugify(brandName, productName)
    return `/products/${slug}/${productHash}`
  }

  export function storeLink(store: IStoreShort) {
    const {id, name, street, city} = store
    const slug = slugify(name, street, city)
    return `/stores/${slug}/${id}`
  }

  function slugify(...parts: ReadonlyArray<string | null | undefined>): string {
    return parts
      .filter((x): x is string => Boolean(x))
      .map(x => x.replace(uriReplaceRegex, "-"))
      .join("-")
  }
}
